export default {"src":"/_next/static/media/asterix.4b71633f.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};